var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type==1)?_c('Type1',{attrs:{"type":_vm.type}}):_vm._e(),(_vm.type==2)?_c('Type2',{attrs:{"type":_vm.type}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }